import React from 'react'

export default function TextFormatWarning({oldType, newType, proceed, cancel}) {
  return (
    <div>
      <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
          <div className="bg-white mx-auto rounded shadow p-5 text-center">
            <p className='text-danger'>You are trying to change from a {oldType} field to a {newType} field, you will loose all data of this field if you proceed</p>
            <div className="pt-3">
                <button onClick={proceed} type="button" className="btn btn-primary mr-2">
                    Proceed
                </button>

                <button onClick={cancel} type="button" className="btn btn-secondary mr-2">
                    Cancel
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
